<template>
  <div>
    <div class="columns">
      <div class="column" style="position: relative; height: 50px">
        <div class="columns">
          <div class="column is-11">
            <div class="columns is-mobile">
              <div class="column">
                <b-tooltip
                  type="is-dark"
                  position="is-right"
                  :label="$translate('copy_dx_in_sx') | capitalize"
                  multilined
                >
                  <a class="button is-primary" :disabled="disabledbool" @click="copyToOtherFoot('right')">
                    <b-icon icon="content-copy" />
                  </a>
                </b-tooltip>
              </div>
              <div class="column is-11">
                <h3 class="subtitle green">
                  {{ $translate('left_foot') | uppercase }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column" style="position: relative; height: 50px">
        <div class="columns">
          <div class="column is-12">
            <div class="columns is-mobile">
              <div class="column is-11">
                <h3 class="subtitle green has-text-right">
                  {{ $translate('right_foot') | uppercase }}
                </h3>
              </div>
              <div class="column is-1">
                <b-tooltip
                  type="is-dark"
                  position="is-left"
                  :label="$translate('copy_sx_in_dx') | capitalize"
                  multilined
                >
                  <a class="button is-primary" :disabled="disabledbool" @click="copyToOtherFoot('left')">
                    <b-icon icon="content-copy" />
                  </a>
                </b-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-narrow">
        <table class="bordered-table dynamic">
          <thead>
            <tr>
              <th></th>
              <th>{{ $translate('height_tomaia') | capitalize }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <b-field
                  :type="{ 'is-danger': errors.has('height_tomaia_sx') }"
                  :message="errors.first('height_tomaia_sx')"
                >
                  <b-input
                    type="number"
                    v-model="values.left.height"
                    v-validate="shoeType === 'low' ? 'between:0,10' : 'between:0,20'"
                    :disabled="disabledbool"
                    name="height_tomaia_sx"
                    :placeholder="$translate('placeholder_numeric_cm')"
                    @input="newVal => onChange(newVal, 'left', 'height')"
                  >
                  </b-input>
                </b-field>
              </td>
              <td class="header">
                <strong>{{ $translate('height_tomaia') | capitalize }}</strong>
              </td>
              <td>
                <b-field
                  :type="{ 'is-danger': errors.has('height_tomaia_dx') }"
                  :message="errors.first('height_tomaia_dx')"
                >
                  <b-input
                    v-model="values.right.height"
                    type="number"
                    v-validate="shoeType === 'low' ? 'between:0,10' : 'between:0,20'"
                    :disabled="disabledbool"
                    name="height_tomaia_dx"
                    :placeholder="$translate('placeholder_numeric_cm')"
                    @input="newVal => onChange(newVal, 'right', 'height')"
                  >
                  </b-input>
                </b-field>
              </td>
            </tr>
            <tr v-if="shoeType === 'high'">
              <td>
                <b-field
                  :type="{ 'is-danger': errors.has('circumference_tomaia_sx') }"
                  :message="errors.first('circumference_tomaia_sx')"
                >
                  <b-input
                    v-model="values.left.circumference"
                    type="number"
                    :disabled="disabledbool"
                    v-validate="`${values.left.height > 0 ? 'required' : ''}|between:0,999|integer`"
                    name="circumference_tomaia_sx"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    @input="newVal => onChange(newVal, 'left', 'circumference')"
                  >
                  </b-input>
                </b-field>
              </td>
              <td class="header">
                <strong>{{ $translate('circumference_tomaia') | capitalize }}</strong>
              </td>
              <td>
                <b-field
                  :type="{ 'is-danger': errors.has('circumference_tomaia_dx') }"
                  :message="errors.first('circumference_tomaia_dx')"
                >
                  <b-input
                    v-model="values.right.circumference"
                    type="number"
                    :disabled="disabledbool"
                    v-validate="`${values.right.height > 0 ? 'required' : ''}|between:0,999|integer`"
                    name="circumference_tomaia_dx"
                    :placeholder="$translate('placeholder_numeric_mm')"
                    @input="newVal => onChange(newVal, 'right', 'circumference')"
                  >
                  </b-input>
                </b-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeasurementsTomaia',
  props: ['shoeType', 'measures', 'disabledbool'],
  inject: ['$validator'],
  data() {
    return {
      values: { left: {}, right: {} },
    }
  },
  watch: {
    measures: {
      handler(newMeasures) {
        this.values = { ...this.values, ...newMeasures }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.$validator.extend('max_10', {
      getMessage: () => this.$translate('max_10'),
      validate: value => value < 10,
    })
    this.$validator.extend('max_20', {
      getMessage: () => this.$translate('max_20'),
      validate: value => value < 20,
    })
  },
  methods: {
    onChange(newValue, foot, header) {
      this.values[foot] = { ...this.values[foot], [header]: newValue }
      this.$emit('update', this.values)
    },
    copyToOtherFoot(foot) {
      if (foot === 'left') {
        this.values.right = { ...this.values.left }
      }
      if (foot === 'right') {
        this.values.left = { ...this.values.right }
      }
      this.$emit('update', this.values)
    },
  },
}
</script>
<style scoped></style>
